module.exports = __webpack_public_path__ + "static/media/NUS_Climbing_Club.af794b2c.jpg";